var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1175_2227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27999 1.91376C7.35335 1.78786 7.45845 1.68341 7.58478 1.61081C7.71112 1.53821 7.85428 1.5 7.99999 1.5C8.1457 1.5 8.28886 1.53821 8.4152 1.61081C8.54153 1.68341 8.64663 1.78786 8.71999 1.91376L10.5833 5.11242L14.202 5.89642C14.3443 5.92735 14.4761 5.99506 14.5841 6.09278C14.6921 6.1905 14.7726 6.31483 14.8176 6.45337C14.8626 6.59191 14.8705 6.73983 14.8405 6.88237C14.8105 7.02491 14.7437 7.1571 14.6467 7.26576L12.18 10.0264L12.5533 13.7098C12.5681 13.8548 12.5445 14.0012 12.4849 14.1342C12.4254 14.2673 12.332 14.3824 12.2141 14.4681C12.0961 14.5538 11.9578 14.6071 11.8128 14.6226C11.6679 14.6381 11.5214 14.6152 11.388 14.5564L7.99999 13.0631L4.61199 14.5564C4.4786 14.6152 4.33212 14.6381 4.18716 14.6226C4.0422 14.6071 3.90385 14.5538 3.7859 14.4681C3.66796 14.3824 3.57457 14.2673 3.51504 14.1342C3.45551 14.0012 3.43193 13.8548 3.44666 13.7098L3.81999 10.0264L1.35332 7.26642C1.25614 7.15777 1.18916 7.02553 1.15907 6.8829C1.12897 6.74027 1.13682 6.59224 1.18182 6.45359C1.22682 6.31494 1.30741 6.19052 1.41553 6.09276C1.52365 5.99499 1.65553 5.92729 1.79799 5.89642L5.41666 5.11242L7.27999 1.91376Z",
    fill: "#FAB623"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1175_2227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/Ic_Star.f483066639ad0a6b3e0e24f1ea5d94af.svg";
export { ForwardRef as ReactComponent };